import preAxios from '../preAxios';
interface selectAllParams {
  s_companyName: string
}
interface ContractType {
  typeId: 1 | 2 | 3
  period: string
  periodNum: Number
  typeInfoId: Array<Number>
}

interface updateContractData {
  companyPhone: string//维保单位联系人电话
  empId: number//维保合同业务处理人
}


interface addContractData extends updateContractData {
  companyName: string//维保单位名称
  companyNumber: string//维保单位营业执照号
  companyPerson: string//维保单位联系人
  companyPhone: string//维保单位联系人电话
  number: string//合同编号
  startDate: string//合同开始日期，年月日
  endDate: string//合同结束日期，年月日
  contractFile: string//合同pdf预览
  ContractTypeList: Array<ContractType>
}

class wContract extends preAxios {
  constructor() {
    super()
  }
  //查询维保合同列表
  static wbListUrl = "operation/wContract/selectAll";
  selectAll(params: selectAllParams): Promise<Object> {
    const that = this;
    return this.$axiosget(wContract.wbListUrl, {
      params: {
        companyName: params.s_companyName
      }
    })
  }
  //添加维保合同
  addContract(data: addContractData): Promise<Object> {
    const that = this;
    return this.$axiospost("operation/wContract/addContract",
      data
    )
  }

  //添加维保合同
  updateContract(data: addContractData): Promise<Object> {
    const that = this;
    return this.$axiospost("operation/wContract/updateContract",
      data
    )
  }

  selectOne(id: Number): Promise<Object> {
    const that = this;
    return this.$axiosget("operation/wContract/selectOne", {
      params: {
        id
      }
    })
  }

  deleteContract(id: Number): Promise<Object> {
    const that = this;
    return this.$axiosdelete("operation/wContract/deleteContract", {
      params: {
        id
      }
    })
  }

}
export default new wContract


// WEBPACK FOOTER //
// ./src/ts/API/operation/wContract.ts